import rangeGenerator from '@/utils/rangeGenerator'

/**
 * @module
 * @name Range
 * @description Custom input range.
 */
export default {
  name: 'Range',

  /**
   * @property {Number} min Mínimum value.
   * @property {Number} max Maximum value.
   * @property {Number} standar Standard value.
   * @property {String} title Label title.
   * @property {Number} initial Initial value.
   * @property {Number} gap Gap between values.
   */
  props: {
    min: {
      type: [String, Number],
      required: true
    },
    max: {
      type: [String, Number],
      required: true
    },
    standard: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    initial: {
      type: [String, Number],
      required: false
    },
    gap: {
      type: [String, Number],
      required: false,
      default: 2
    }
  },

  /**
   * @property {Integer} value Local value.
   * @property {Integer} interval Local interval.
   */
  data: function () {
    return {
      value: 0,
      interval: 10
    }
  },

  /**
   * @property {Array} scale Array of numbers, range generated.
   * @property {Number} rangePercent Max - min
   */
  computed: {
    scale () {
      return rangeGenerator(this.min, this.max, this.gap)
    },
    rangePercent () {
      return this.max - this.min
    }
  },

  methods: {
    /**
     * @function
     * @name getRelativePercent
     * @description Returns relative percent from the start of the range.
     * @param {Float|Integer} v Value
     */
    getRelativePercent (v) {
      return (v - this.min) / (this.max - this.min)
    },

    /**
     * @function
     * @name moveLabel
     * @description Sets label, text and local value.
     */
    moveLabel () {
      let rangeVal = this.$el.querySelector('#range-slider').value
      let label = this.$el.querySelector('#range-label')
      label.innerHTML = rangeVal
      this.$el.querySelector('.range__label').style.left = this.getRelativePercent(rangeVal) * 100 + '%'
      this.$el.querySelector('.range__label').style.transform = 'translateX(calc(-50% )'
    },

    /**
     * @function
     * @name handleChange
     * @param {Object} $event
     * @description Emits an event with the value.
     */
    handleChange ($event) {
      this.$emit('change', parseInt($event.target.value))
    },

    /**
     * @function
     * @name createScale
     * @description Moves each separator from left border.
     */
    createScale () {
      const scaleMarks = this.$el.querySelectorAll('.range__scaleMark')

      this.scale.forEach((v, idx) => {
        const el = scaleMarks[idx]
        if (el) {
          el.style.left = 'calc(' + (this.getRelativePercent(v) * 100) + '% - ' + ((idx * 2) + 0.5) + 'px'
        }
      })
    }
  },

  /**
   * @function
   * @name beforeMount
   * @description Set value initially.
   */
  beforeMount: function () {
    this.value = this.initial || this.standard
  },

  /**
   * @function
   * @name mounted
   * @description Create scale and set initial positions.
   */
  mounted () {
    this.moveLabel()
    this.$el.querySelector('.range__val--standard').style.left = this.getRelativePercent(this.standard) * 100 + '%'
    this.createScale()
    this.$el.querySelector('#range-slider').value = this.value
  }
}
